import React, { Component } from 'react'
import PropTypes from 'prop-types'

const BADGE_TYPES = [
  'error',
  'success',
  'warning',
  'primary',
  'secondary',
  'error-light',
  'success-light',
  'warning-light',
  'primary-light',
  'secondary-light',
]

class Badge extends Component {
  static propTypes = {
    /* The text that will be displayed inside the badge */
    text: PropTypes.string.isRequired,

    /* The type of the badge, it changes the badge colors */
    badgeType: PropTypes.oneOf(BADGE_TYPES),

    className: PropTypes.string
  }

  render() {
    const { text, badgeType, className } = this.props

    return (
      <>
        <span className={`badge badge-${badgeType} ${className}`}>{text}</span>
      </>
    )
  }
}

export default Badge
